import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from '../../util/Api';

import {
  CANCEL_ATA_SUCCESS,
  CLEAR_ARN_DATA_SUCCESS,
  CREATE_ASSET_RECEIPT_NOTE_SUCCESS,
  FETCH_ARN_NO_SUCCESS,
  FETCH_ASSET_LIST_BY_ATA,
  FETCH_ASSET_RECEIPT_NOTE_SUCCESS,
  FETCH_METER_UNIT_SUCCESS_ARN,
  GET_ASSET_RECEIPT_NOTE_SUCCESS,
  SAVE_ASSET_RECEIPT_NOTE_QUERY,
} from '../../constants/ActionTypes';

import axios from 'util/Api';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_ASSET_RECEIPT_NOTE_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ASSET_RECEIPT_NOTE_QUERY,
    query,
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_ASSET_RECEIPT_NOTE_SUCCESS,
    data,
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_RECEIPT_NOTE_SUCCESS,
    data,
  };
};

export const fetchUnitSuccess = (data) => {
  return {
    type: FETCH_METER_UNIT_SUCCESS_ARN,
    data
  };
};

export const fetchAssetListByAtaSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_LIST_BY_ATA,
    data,
  };
};

export const fetchArnNoSuccess = ({ data }) => {
  return {
    type: FETCH_ARN_NO_SUCCESS,
    data,
  };
};

export const cancelAtaSuccess = ({ data }) => {
  return {
    type: CANCEL_ATA_SUCCESS,
    data,
  };
};

export const clearArnData = () => {
  return {
    type: CLEAR_ARN_DATA_SUCCESS,
  }
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { assetReceiptNote } = store.getState();
      const { query } = assetReceiptNote;
      const response = await axios.get(`/asset-receipt-note?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { assetReceiptNote } = store.getState();
      const { query } = assetReceiptNote;
      const response = await axios.get(`/asset-receipt-note/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = { ...item };
        delete data.file;
        documentData.push(data);
      });

      formData.append('documentData', JSON.stringify(documentData));

      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return;
        }
        if (key === 'receivedBy' || key === 'readings' || key === 'dependentAssets') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }
        formData.append(key, payload[key]);
      });

      const response = await axios.post(`/asset-receipt-note`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));
      history.push('/asset-receipt-note');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log('Error****:', error);
    }
  };
};

export const fetchMeterUnit = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    let query = '';
    Object.entries(data).forEach(([key, value], index) => {
      if(Object.keys(data).length - 1 === index) {
        query += `${key}=${value}`
      } else {
        query += `${key}=${value}&`
      }
    });
    try {
      const response = await axios.get(`/interval/unit?${query}`);
      dispatch(fetchSuccess());
      dispatch(fetchUnitSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      const documentIds = [];
      payload.documents.map((item, index) => {
        if (!item.file.path) {
          formData.append('files', item.file);
          let data = { ...item };
          delete data.file;
          documentData.push(data);
        } else {
          documentIds.push(item._id);
        }
      });

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('documentIds', JSON.stringify(documentIds));

      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return;
        }
        if (key === 'receivedBy' || key === 'readings' ||  key === 'dependentAssets') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }
        formData.append(key, payload[key]);
      });

      await axios.put(`/asset-receipt-note/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      dispatch(fetchSuccess());
      history.push('/asset-receipt-note');
      dispatch(getResource());
    } catch (error) {
      console.log('Error****:', error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};

export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/asset-receipt-note/${id}`);
      dispatch(fetchSuccess());

      if(response && response.data && response.data.assets && response.data.assets.length) {
        for(let i=0; i < response.data.assets.length; i++) {
         let obj =  response.data.assets[i];
          if(response.data.readings && response.data.readings.length) {
            for(let j=0; j < response.data.readings.length ; j++) {
              if(obj._id === response.data.readings[j].asset._id) {
                obj.meter = response.data.readings[j].meter || '';
                obj.meterUnit = response.data.readings[j].meterUnit || '';
              }
            }
          }
        }
      }

      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/asset-receipt-note/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchAssetListByAta = (ata) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    let query = '';
    if (ata) {
      query = `ata=${ata}`;
    }
    try {
      const response = await axios.get(`/asset-transfer-advice/getAssetByAta?${query}`);
      dispatch(fetchSuccess());
      dispatch(fetchAssetListByAtaSuccess(response));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchArnNo = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get('/asset-receipt-note/getArnNo');
      dispatch(fetchSuccess());
      dispatch(fetchArnNoSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const cancelAta = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axios.post('/asset-receipt-note/cancelAta', payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));
      history.push('/asset-receipt-note');
      dispatch(getResource());
    } catch(error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchAllMeterUnit = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/interval/allMeterUnitAta`);
      dispatch(fetchSuccess());
      dispatch(fetchUnitSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};
